import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section
      className="relative w-full min-h-[520px] md:min-h-[680px] flex items-center justify-center overflow-hidden"
      aria-label="首页横幅"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20organic%20shapes%20flowing%20harmoniously%20in%20warm%20green%20and%20amber%20gradients%2C%20creative%20brand%20content%20visualization%20art%2C%20soft%20ethereal%20background%20with%20gentle%20curves%20and%20layers%2C%20editorial%20art%20style%20with%20smooth%20color%20transitions%2C%20calm%20and%20professional%20atmosphere%2C%20non-photorealistic%20artistic%20composition&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="黄瓜传媒品牌背景"
          className="w-full h-full object-cover"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 md:px-6 max-w-4xl mx-auto w-full">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight mb-4 md:mb-6 animate-slide-up">
          让每一次传播
          <br />
          <span className="text-accent-400">产生真实价值</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed animate-slide-up" style={{ animationDelay: '0.15s' }}>
          黄瓜传媒专注于品牌内容创作、数字营销与媒体传播，为企业提供创意策划、视频制作、社交媒体运营等一站式传播解决方案
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 animate-slide-up" style={{ animationDelay: '0.3s' }}>
          <Link
            to="/category/brand-planning"
            className="px-7 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            探索服务
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap border border-white/25"
          >
            了解我们
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-white/40 flex items-start justify-center pt-2">
          <div className="w-1.5 h-1.5 rounded-full bg-white/70" />
        </div>
      </div>
    </section>
  );
}